export default function DailyDoubleField() {
  return <span>Coming soon</span>;
}
